import makeApiRequest from './makeApiRequest';

interface TaxPayload {
	amount: number;
	rate: number;
	taxableSubtotal: number;
	status: string;
	selectedExempt: boolean;
}

interface SaleRequestBody {
	amount: number;
	billToForename: string;
	billToSurname: string;
	tax: TaxPayload;
	transientTokenJwt: string;
}

interface PayoffRequestBody {
	amount: number;
	billToForename: string;
	billToSurname: string;
	transientTokenJwt: string;
}

const postCbsCharge = () => {
	const postApiRequest = makeApiRequest('POST');

	const postSale = async (apiBase: string, body: SaleRequestBody) => postApiRequest(`${apiBase}/api/cyber-source/sale`, body);

	const postPayoff = async (apiBase: string, fairId: string, body: PayoffRequestBody) => postApiRequest(`${apiBase}/api/cyber-source/payoff?fairId=${encodeURIComponent(fairId)}`, body);

	return [postSale, postPayoff] as const;
};

export default postCbsCharge;
